import * as React from 'react';

import * as wjChart from '@grapecity/wijmo.react.chart';
import * as wjGrid from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';

import { Col, Row, Container } from 'react-bootstrap';
import { useEffect, useState } from 'react';

import { toInt, calcRate } from 'utils/numberUtils';
import AnalysisKingakuTankaBigSmall from 'views/Analysis/AnalysisKingakuTankaBigSmall';
import './Analysis.css';

// 分析（契約単価）（工事／管・小）
function AnalysisKingakuBigSmall(props) {
  // 契約情報リスト
  const keiyakuList = props.quoteList;

  // 選択中の期
  const selectedPeriod = props.selectedPeriod;

  // 工事のリピート件数
  const [bigRepeatCount, setBeforeRepeatCount] = useState(0);
  // 工事の新規件数
  const [bigNewCount, setBeforeNewCount] = useState(0);
  // 小工事のリピート件数
  const [smallRepeatCount, setCurrentRepeatCount] = useState(0);
  // 小工事の新規件数
  const [smallNewCount, setCurrentNewCount] = useState(0);

  // グリッドのキー
  const [gridKey, setGridKey] = useState(0);

  useEffect(() => {
    // グリッドの再描画のためにキーを変更
    setGridKey((prev) => prev + 1);

    // 前期のリピート・新規件数を計算
    setBeforeRepeatCount(
      keiyakuList.sourceCollection.reduce((sum, item) => sum + toInt(item.KIN_BIG_REPEAT, 0), 0)
    );
    setBeforeNewCount(
      keiyakuList.sourceCollection.reduce((sum, item) => sum + toInt(item.KIN_BIG_NEW, 0), 0)
    );

    // 今期のリピート・新規件数を計算
    setCurrentRepeatCount(
      keiyakuList.sourceCollection.reduce((sum, item) => sum + toInt(item.KIN_SMALL_REPEAT), 0)
    );
    setCurrentNewCount(
      keiyakuList.sourceCollection.reduce((sum, item) => sum + toInt(item.KIN_SMALL_NEW, 0), 0)
    );
  }, [keiyakuList]);

  //  グリッドの初期化
  function onInitialized(grid) {
    // ヘッダーを2段にする
    var extraRow = new wjGrid.Row();
    extraRow.cssClassAll = 'header-center';
    extraRow.allowMerging = true;

    var panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);

    for (let colIndex = 1; colIndex <= 2; colIndex++) {
      panel.setCellData(0, colIndex, 'リピート');
    }
    for (let colIndex = 3; colIndex <= 4; colIndex++) {
      panel.setCellData(0, colIndex, '新規');
    }
    for (let colIndex = 5; colIndex <= 6; colIndex++) {
      panel.setCellData(0, colIndex, '合計');
    }

    // 垂直方向にマージ
    ['MONTH'].forEach(function (binding) {
      let col = grid.getColumn(binding);
      col.allowMerging = true;
      panel.setCellData(0, col.index, col.header);
    });

    grid.formatItem.addHandler((sender, e) => {
      // フッターセルのスタイル設定
      if (e.panel === sender.columnFooters) {
        const colIndex = e.col;
        const rowIndex = e.row;

        // フッターの1行目の線を太くする
        if (rowIndex === 0) {
          e.cell.style.borderTop = 'double';
        }

        if (rowIndex == 0 && [1, 3, 5].includes(colIndex)) {
          // 工事件数
          e.cell.style.backgroundColor = '#d9e1f2';
        } else if (rowIndex == 0 && [2, 4, 6].includes(colIndex)) {
          // 小工事件数
          e.cell.style.backgroundColor = '#ffff99';
        } else {
          // 他のセルの背景色をデフォルトに戻す
          e.cell.style.backgroundColor = '';
        }
      }
    });

    // フッターに１段追加
    grid.columnFooters.rows.push(new wjGrid.Row());

    // データ変更時に合計更新
    grid.collectionView.collectionChanged.addHandler(updateFooter);
    updateFooter(grid);
  }

  // 合計値を計算してフッターに設定
  function updateFooter(grid) {
    let data = grid?.itemsSource?.items;
    if (!data || data.length === 0) return;

    let panel = grid.columnFooters;

    grid.columns.forEach((col, colIndex) => {
      const binding = col.binding;
      if (binding === 'MONTH') {
        // 月
        panel.setCellData(0, colIndex, '合計');
      } else {
        // 今期
        let total = data.reduce((sum, item) => sum + (item[binding] || 0), 0);
        panel.setCellData(0, colIndex, total);
      }
    });
  }

  return (
    <Container fluid className="p-0">
      <AnalysisKingakuTankaBigSmall keiyakuList={keiyakuList} selectedPeriod={selectedPeriod} />
      <Row className="mt-2">
        <Col className="pl-3" md="7">
          <FlexGrid
            key={gridKey}
            isReadOnly={true}
            allowMerging="ColumnHeaders"
            allowSorting={false}
            allowDragging={false}
            itemsSource={keiyakuList}
            headersVisibility={'Column'}
            alternatingRowStep={0}
            initialized={onInitialized}
          >
            <FlexGridColumn
              binding="MONTH"
              header="月"
              allowMerging={true}
              width={60}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_BIG_REPEAT"
              cssClass="big_cell"
              header="工事"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_SMALL_REPEAT"
              cssClass="small_cell"
              header="管・小"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_BIG_NEW"
              cssClass="big_cell"
              header="工事"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_SMALL_NEW"
              cssClass="small_cell"
              header="管・小"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_BIG_TOTAL"
              cssClass="total_cell"
              header="工事"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_SMALL_TOTAL"
              cssClass="total_cell"
              header="管・小"
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
          </FlexGrid>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="pl-3" md="6">
          <wjChart.FlexChart
            header={`工事　リピート・新規（契約金額）【累計】`}
            itemsSource={keiyakuList.sourceCollection}
            bindingX="MONTH"
            chartType="Line"
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
          >
            {/* Y軸の最大・最小値を設定 */}
            <wjChart.FlexChartAxis wjProperty="axisY" min={0} />
            {/* X軸にY方向のグリッド線を表示 */}
            <wjChart.FlexChartAxis wjProperty="axisX" majorGrid={true} />
            {/* 凡例の位置を下に配置 */}
            <wjChart.FlexChartLegend position="Bottom" />
            <wjChart.FlexChartSeries name={`リピート`} binding="KIN_BIG_REPEAT" />
            <wjChart.FlexChartSeries name={`新規`} binding="KIN_BIG_NEW" />
          </wjChart.FlexChart>
        </Col>
        <Col className="pl-3" md="6">
          <wjChart.FlexChart
            header={`管・小　リピート・新規（契約金額）【累計】`}
            itemsSource={keiyakuList.sourceCollection}
            bindingX="MONTH"
            chartType="Line"
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
          >
            {/* Y軸の最大・最小値を設定 */}
            <wjChart.FlexChartAxis wjProperty="axisY" min={0} />
            {/* X軸にY方向のグリッド線を表示 */}
            <wjChart.FlexChartAxis wjProperty="axisX" majorGrid={true} />
            {/* 凡例の位置を下に配置 */}
            <wjChart.FlexChartLegend position="Bottom" />
            <wjChart.FlexChartSeries name={`リピート`} binding="KIN_SMALL_REPEAT" />
            <wjChart.FlexChartSeries name={`新規`} binding="KIN_SMALL_NEW" />
          </wjChart.FlexChart>
        </Col>
      </Row>
      <Row className="mt-2">
        {/* 工事のリピート・新規件数の円グラフ */}
        <Col className="pl-3" md="6">
          <wjChart.FlexPie
            header={`工事　リピート・新規（契約金額）【累計】`}
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
            itemsSource={[
              {
                category: 'リピート',
                value: bigRepeatCount,
                rate: bigRepeatCount / (bigRepeatCount + bigNewCount),
              },
              {
                category: '新規',
                value: bigNewCount,
                rate: bigNewCount / (bigRepeatCount + bigNewCount),
              },
            ]}
            bindingName="category"
            binding="value"
            startAngle={90}
          >
            <wjChart.FlexPieDataLabel content="{name}({rate:p0})" position="Center" />
          </wjChart.FlexPie>
        </Col>
        {/* 小工事のリピート・新規件数の円グラフ */}
        <Col className="pl-3" md="6">
          <wjChart.FlexPie
            header={`管・小　リピート・新規（契約金額）【累計】`}
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
            itemsSource={[
              {
                category: 'リピート',
                value: smallRepeatCount,
                rate: smallRepeatCount / (smallRepeatCount + smallNewCount),
              },
              {
                category: '新規',
                value: smallNewCount,
                rate: smallNewCount / (smallRepeatCount + smallNewCount),
              },
            ]}
            bindingName="category"
            binding="value"
            startAngle={90}
          >
            <wjChart.FlexPieDataLabel content="{name}({rate:p0})" position="Center" />
          </wjChart.FlexPie>
        </Col>
      </Row>
    </Container>
  );
}
export default AnalysisKingakuBigSmall;
